export const ROLE_ADMIN = "Admin";
export const ROLE_CLIENT = "Client";
export const ROLE_BUSINESS = "Business";

const ROLE_ALIASES = Object.freeze({
  admin: ROLE_ADMIN,
  adminuser: ROLE_ADMIN,
  client: ROLE_CLIENT,
  userclient: ROLE_CLIENT,
  business: ROLE_BUSINESS,
  userbusiness: ROLE_BUSINESS,
});

export const normalizeRole = (role, fallback = "undefined") => {
  if (role === undefined || role === null) {
    return fallback;
  }

  const trimmedRole = String(role).trim();
  if (!trimmedRole) {
    return fallback;
  }

  return ROLE_ALIASES[trimmedRole.toLowerCase()] || trimmedRole;
};

export const isRole = (candidateRole, expectedRole) =>
  normalizeRole(candidateRole, null) === expectedRole;
